import parse from "html-react-parser";
import {FeatureCardIconsHandler} from "@/components/feuture-card-icons";

export default function FeatureCard({title, desc, logoKey}) {
    return (
        <div className="feature-card group border-2 lg:border-none w-full flex flex-col items-center bg-white rounded-[1.688rem] px-[1.438rem] pt-[1.563rem] pb-8 duration-300 hover:shadow-[0_0_16px_10px_rgba(219,213,231,0.14)]">
            <div className="w-16 h-16 rounded-[0.938rem] border-pol-blue border-[0.188rem] lg:border-[#F4F2FA] group-hover:lg:border-pol-blue box-border duration-300">
                <div className="relative flex justify-center items-center w-full h-full">

                    <FeatureCardIconsHandler
                        classes="group-hover:fill-pol-blue"
                        logoKey={logoKey}
                    />
                </div>
            </div>
            <p className="font-bold text-pol-dark-brown mt-4 group-hover:text-pol-dark-800 feature-card-title duration-300">{title}</p>
            <div className="mt-3.5 font-semibold text-[0.813rem] text-pol-light-brown text-center pol-leading-m group-hover:text-pol-gray-600 feature-card-desc duration-300">
                {parse(desc || "<span></span>")}
            </div>
        </div>
    )
}
